<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";
import { format } from "date-fns";

const timeNow = ref<string>();

let timeout: NodeJS.Timeout;

const getTime = (): void => {
  const dateNow = new Date();
  timeNow.value = format(dateNow, "hh:mmaaa");
  // dateNow.getSeconds() is the offset from real time
  timeout = setTimeout(getTime, Math.max(0, (60 - dateNow.getSeconds()) * 1000));
};

onMounted(() => {
  getTime();
});

onUnmounted(() => {
  clearTimeout(timeout);
});
</script>

<template>
  <div class="app-navbar-clock">
    <span class="icon fa-solid fa-fw fa-clock" />
    <span class="text">{{ timeNow }}</span>
  </div>
</template>

<style lang="scss" scoped>
.app-navbar-clock {
  align-items: center;
  color: #fff;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;

  .text {
    font-size: 1.25rem;
    font-weight: 400;
    letter-spacing: -0.015em;
  }
}
</style>
